import React from 'react';
import { JWNET_MAXIMUM_WEIGHT, REGEX_OBJECT } from 'util/ConstantValues';

const MINIMUM_WEIGHT = 0;

const isValidWeightInput = (value: string) => {
  if (!value) {
    return true;
  }

  if (!REGEX_OBJECT.fiveDigitsWith2Decimal.test(value)) {
    return false;
  }

  const numericValue = Number(value);

  return numericValue >= MINIMUM_WEIGHT && numericValue <= JWNET_MAXIMUM_WEIGHT;
};

type WeightInputProps = Omit<
  React.ComponentPropsWithoutRef<'input'>,
  'type' | 'inputMode' | 'value' | 'onChange' | 'onSubmit'
> & {
  value: string;
  onChange: (value: string) => void;
  onCancel?: () => void;
  onSubmit?: (val: string) => void;
};

const WeightInput = ({
  value,
  onChange,
  onCancel,
  onSubmit,
  ...props
}: WeightInputProps) => {
  const [internalValue, setInternalValue] = React.useState(value);

  React.useEffect(() => {
    setInternalValue(value);
  }, [value]);

  const handleChange = (nextValue: string) => {
    if (!isValidWeightInput(nextValue)) {
      return;
    }

    onChange(nextValue);
    setInternalValue(nextValue);
  };

  return (
    <input
      {...props}
      type="text"
      inputMode="decimal"
      value={internalValue}
      onChange={(e) => handleChange(e.target.value)}
      onKeyDown={({ code }) => {
        if (code === 'Enter') {
          onSubmit?.(internalValue);
        } else if (code === 'Escape') {
          onCancel?.();
        }
      }}
    />
  );
};

export default WeightInput;
